<!-- workbench-卡片 -->
<template>
  <div class="workbench_card_datareport_style" v-loading="data.datareportLoading">
    <div id="mainCharts"></div>
  </div>
</template>




<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import {reactive,getCurrentInstance,onMounted,defineComponent, onBeforeMount, nextTick, onUpdated, ref, defineEmit, computed} from "vue";
  import * as echarts from 'echarts'
  import { useRoute } from "vue-router"
  export default defineComponent({
    name: "workbenchCard",
    props :{
        startTime: {
          type: String,
          default() {
                return ''
            }
        },
        endTime: {
          type:String,
          default() {
                return ''
            }
        },
        activeNameOfDatareport:{
          type:String,
          default() {
                return ''
            }
        },
        userData:{
          type:Object,
          default() {
                return {}
            }
        }
      },
      emits:{},
    setup(props, { expose }){
      const { proxy, ctx } = getCurrentInstance();
      const route = useRoute();
      const data = reactive({
        monthList:[],
        dataList:[],
        datareportLoading:false,
        maxNumber:0,
      })
      const changeOfDatareport = (activeName)=>{
        data.dataList = null
        nextTick(()=>{
          getInfo(activeName)
        })
      }
      const getMonth = (start, end) => {
        const result = [];
        const [startYear, startMonth] = start.split('-').map(Number);
        const [endYear, endMonth] = end.split('-').map(Number);

        // 创建开始和结束日期对象（只关注年月）
        const startDate = new Date(startYear, startMonth - 1, 1);
        const endDate = new Date(endYear, endMonth - 1, 1);

        // 当前日期从开始日期开始
        let currentDate = new Date(startDate);

        // 使用年份和月份的组合作为终止条件，避免时间精度问题
        while (
          currentDate.getFullYear() < endYear || 
          (currentDate.getFullYear() === endYear && currentDate.getMonth() <= endMonth - 1)
        ) {
          // 格式化并添加到结果数组
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, '0');
          result.push(`${year}-${month}`);
          
          // 安全增加月份（自动处理跨年）
          currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
        }

        return result;
      };
      // 查询/更新数据
      const getInfo = (activeName)=>{
        // console.log(props.startTime)
        // console.log(props.endTime)
        let startDate = proxy.time(props.startTime).substring(0,proxy.time(props.startTime).lastIndexOf('-'))
        let endDate = proxy.time(props.endTime).substring(0,proxy.time(props.endTime).lastIndexOf('-'))
        data.monthList = getMonth(startDate,endDate)
        // console.log('monthList',data.monthList)
        let url = null
        if(activeName === '入厂不合格'){
          url = '/base/hmqm/batchPlanFailMonthCount'
          data.legendData = [h_i18n('5b173bbab61d42407f15de45e680bdbb')]
        }else if(activeName === '模块停检'){
          url = '/base/hmqm/rejectsStop'
          data.legendData = [h_i18n('c8cef6cdef723c4ad02f073b97256f20')]
        }else if(activeName === '质量损失'){
          url = '/base/hmqm/qualityLossCount'
          data.legendData = [h_i18n('4bce9ce9b6e2f34baadc06e3b759a274')]
        }else if(activeName === '质量得分'){
          url = '/base/'
          data.legendData = [h_i18n('b6495723c23af95d5cc5fc85992a2825')]
        }else { // 默认进入
          url = '/base/hmqm/batchPlanFailMonthCount'
          data.legendData = [h_i18n('5b173bbab61d42407f15de45e680bdbb')]
        }
        data.datareportLoading = true
        proxy.$http({
          url,
          method: "post",
          data: {
            startTime: startDate,
            endTime : endDate,
            supplyCode : props.userData.supplyCode,
            roleCode : props.userData.roleCode,
            fixConfig: true, 
          }
        }).then(res=>{
          if(res.data.code === '0'){
            if(res.data.data?.length > 0){   
              let dataTemp = res.data.data
              // 处理数据，补充空的月份
              data.dataList = data.monthList.map(item=>{
                let temp = 0
                data.leftWidth = 38
                dataTemp.forEach(element => {
                  if(element.monthTime === item){
                    if(activeName === '质量损失'){
                      temp = element.claimCount || 0
                      data.maxNumber = temp > data.maxNumber ? temp : data.maxNumber
                    }else if(activeName === '入厂不合格'){
                      temp = element.batchPlanFailCount || 0
                      data.maxNumber = temp > data.maxNumber ? temp : data.maxNumber
                    }else if(activeName === '模块停检'){
                      temp = element.rejectsStopCount || 0
                      data.maxNumber = temp > data.maxNumber ? temp : data.maxNumber
                    }else if(activeName === '质量得分'){
                      temp = element.claimScore || 0
                      data.maxNumber = temp > data.maxNumber ? temp : data.maxNumber
                    }
                  }
                })
                return temp
              })
              data.leftWidth = data.maxNumber.toString().split('.')[0].length * 10 + 8
              // console.log('data.leftWidth-------------',data.maxNumber.toString().split('.')[0].length,data.leftWidth)
              data.maxNumber = 0
            }else{
              data.dataList = data.monthList.map(item=>0)
            }
            // if(activeName === '质量损失'){
            //   data.dataList2 = [100,200,145]
            // }else{
            //   data.dataList2 = null
            // }
            // init()
          }
        }).catch(err=>{
          data.dataList = data.monthList.map(item=> 0)
          console.log(err)
        }).finally(()=>{
          init()
          data.datareportLoading = false
        })
      }
    
      const init = ()=>{
        let myChart = echarts.init(document.getElementById('mainCharts'))
        //配置图表
        var option = {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: data.legendData,
            x:'right',
            padding: [10 ,20, 0 , 0]
          },
          grid:{
            x: data.leftWidth || 38,
            y: 18,
            y2: 28,
            x2: 0,
          },
          xAxis: {
            type: 'category',
            data: data.monthList
          },
          yAxis: {
            type: 'value',
            splitLine:{
              lineStyle:{
                show:true,
                type:'dashed'
              }
            }
          },
          series: [
            {
              name: data.legendData[0],
              data: data.dataList,
              type: 'line',
              symbol:'circle',
              symbolSize:[8,8],
              smooth: true,
              itemStyle: {
              normal: {
                color: '#165DFF', // 改变折线点的颜色
                lineStyle: {
                  color: '#165DFF' // 改变折线颜色
                  }
                }
              }
            },
          ]
        }
        option && myChart.setOption(option)
        window.onresize = myChart.resize
      }
      onMounted(()=>{
        // getInfo()
      })
      return{
        changeOfDatareport,
        props,
        data,
        h_i18n
      }
    }
  })
</script>

<style lang="scss">
.workbench_card_datareport_style{
  height: 290px;
  width: 100%;
  #mainCharts{
    min-width:770px;
    height:100%;
    width: calc(100% - 16px);
  }
}
</style>